import { createSessionActivity, parseStoredSession, type StoredSession } from '@keji/api-client';

/**
 * PC 管理端登录态只放 sessionStorage：关闭浏览器即清除，降低共享电脑与
 * XSS 后长期令牌被持续复用的窗口。旧版本留下的 localStorage 会在首次读取时
 * 一次性迁入当前标签会话并删除。
 */
export const sessionActivity = createSessionActivity();
const KEY = 'keji.session';
export const SESSION_CHANGE_EVENT = 'crm.session.changed';

export type { StoredSession } from '@keji/api-client';

export function readSession(): StoredSession | null {
  try {
    const current = parseStoredSession(sessionStorage.getItem(KEY));
    if (current) return current;
    const legacy = parseStoredSession(localStorage.getItem(KEY));
    if (!legacy) return null;
    sessionStorage.setItem(KEY, JSON.stringify(legacy));
    localStorage.removeItem(KEY);
    return legacy;
  } catch {
    return null;
  }
}

export function writeSession(s: StoredSession): void {
  sessionActivity.reset();
  sessionStorage.setItem(KEY, JSON.stringify(s));
  localStorage.removeItem(KEY);
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(SESSION_CHANGE_EVENT));
}

export function clearSession(): void {
  sessionStorage.removeItem(KEY);
  localStorage.removeItem(KEY);
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(SESSION_CHANGE_EVENT));
}
